export const FAN_STYLE_OPTIONS = {
  fanCareerLevel: ['newbie', 'veteran'],
  stanningStyle: ['all_in', 'realist', 'homebody', 'ghost'],
  affectionType: ['romantic', 'maternal'],
  fantasyType: ['rps', 'napess', 'all_rounder', 'non_rps'],
  fandomSocialStyle: ['social', 'solo']
};

export const STEP_ORDER: (keyof typeof FAN_STYLE_OPTIONS)[] = [
  'fanCareerLevel',
  'stanningStyle',
  'affectionType',
  'fantasyType',
  'fandomSocialStyle'
];
